export default "__VITE_ASSET__Bu3wItUM__ 100w";